<template>
  <v-container fluid class="px-0">
    <el-overlay-loading :loading="pageloading" />
    <!-- title  -->
    <h1 class="mb-1" style="display: flex;">{{ $t('Mano įgaliojimai') }}<el-tooltip tooltip="IR savitarna. Pradžia. Įgaliojimų registras. Mano įgaliojimai. Mano įgaliojimai" mainTitle></el-tooltip></h1>
    <!-- search -->
    <mandates-search :loading="loading" @search="searchRecords" />
    <!-- table -->
    <v-data-table
      class="mb-4 custom-table sticky-header-sav"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal')
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <!-- custom templates -->
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            @editItem="editItem(item)"
            @viewItem="viewItem(item)"
            @deleteItem="deleteItem(item)"
            @refuseItem="refuseItem(item)"
            @terminateItem="terminateItem(item)"
            @subdelegateItem="subdelegateItem(item)"
          />
        </div>
      </template>
      <template #[`item.term`]="{ item }">
        <v-tooltip max-width="600" top>
          <template v-slot:activator="{ on, attrs }">
            <a class="lg-text-field" v-bind="attrs" v-on="on">{{
              item.term
            }}</a>
          </template>
          <span>{{ item.term }}</span>
        </v-tooltip>
      </template>
      <template #[`item.mandate_type_title_lt`]="{ item }">
        <span class="text-wb">{{item.mandate_type_title_lt}}</span>
      </template>
      <template #[`item.mandate_type_title_en`]="{ item }">
        <span class="text-wb">{{item.mandate_type_title_en}}</span>
      </template>
      <template #[`item.status`]="{ item }">
        <el-table-enum enumName="mandateStatus" :item="item.status" />
      </template>
      <!-- basic templates -->
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }} {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
  </v-container>
</template>

<script>
import MandatesSearch from './MandatesSearch'
import userRole from '@/mixins/userRole'
import tableParameters from '@/mixins/tableParameters'
import { mapGetters } from 'vuex'

export default {
  name: 'Mandates',
  components: {
    MandatesSearch,
  },
  mixins: [userRole, tableParameters],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      search: null,
      listData: [],
      searchData: {},

      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
        totalPages: 0,
        sort: '',
        sortDesc: [true],
        direction: 'asc',
      },
    }
  },
  computed: {
    ...mapGetters(['menuState']),
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
          width: '8rem',
        },
        {
          text: this.$t('Identifikavimo kodas'),
          align: 'center',
          value: 'code',
          width: '7rem',
        },
        {
          text: this.$t('Įgaliojimo tipas'),
          align: 'center',
          value: this.getMandateTypeByLang,
          width: '10rem',
        },
        {
          text: this.$t('Įregistravimo data'),
          align: 'center',
          value: 'registration_date',
          width: '7rem',
        },
        {
          text: this.$t('Terminas'),
          align: 'center',
          value: 'term',
          width: '5rem',
        },
        {
          text: this.$t('Būsena'),
          align: 'center',
          value: 'status',
          width: '8rem',
        },
      ]
    },
    getMandateTypeByLang() {
      return this.$i18n.locale === 'lt'
        ? 'mandate_type_title_lt'
        : 'mandate_type_title_en'
    },
    filteredHeader() {
      return this.headers.filter((item) => {
        return !item.hide
      })
    },

    filterItemList() {
      return this.listData.map((item) => {
        return item
      })
    },

    hideFooter() {
      return this.pagination.total <= 10
    },
    canPrint() {
      return this.filterItemList.length === 0
    },
  },
  created() {
    this.isMenuState()
    // this.setlistParams()
  },
  methods: {
    isMenuState(){
      if(this.menuState == 'show_only_statements'){
        this.$router.push({
          name: 'savInfoPage',
          params: {
            type: 'showOnlyStatements',
          },
        })
      }
    },
    getData(resetPageNr = false) {
       if(this.menuState == 'show_only_statements'){
        return
      }
      if (resetPageNr) {
        this.pagination.page = 1
      }

      this.setSortParams()

      const data = {
        ...this.pagination,
        search: this.searchData,
      }

      this.$axios
        .post(`mandates/list`, data)
        .then((res) => {
          this.listData = res.data.mandates
          this.pagination = { ...this.pagination, ...res.data.pagination }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
          pageSize: pagination.itemsPerPage,
          page: pagination.page,
          route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'

      if (!this.loading) {
        this.getData()
      }
    },
    searchRecords(searchData) {
      this.searchData = searchData
      this.loading = true
      this.getData(searchData.btn)
    },
    refuseItem(item) {
      this.$router.push({
        name: 'savMandateRefuse',
        params: {
          id: item.id,
        },
      })
    },
    terminateItem(item) {
      this.$router.push({
        name: 'savMandateTerminate',
        params: {
          id: item.id,
        },
      })
    },
    viewItem(item) {
      this.$router.push({
        name: 'savMandateView',
        params: {
          id: item.id,
        },
      })
    },
    subdelegateItem(item) {
      this.$router.push({
        name: 'subMandateSteps',
        params: {
          step: 1,
          parentId: item.id,
        },
      })
    },
    editItem(item) {
      this.$router.push({
        name: 'mandateSteps',
        params: {
          step: 1,
          id: item.id,
        },
      })
    },
  },
}
</script>
<style lang="scss" scoped>
.potipis {
  background: #8eb693;

  .v-card__text {
    &.active {
      background: #2c7837;
      color: #fff;
    }
  }
}
.tikrina-chip {
  max-width: 110px;
}
.lg-text-field {
  // display: block;
  // overflow: hidden;
  // text-overflow: ellipsis;
  width: 5rem;
  // white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
